import { AccountSelectType } from "@ob/layouts/VendorOnboarding/types/payDest";

const accountTypes: AccountSelectType[] = [
  { name: "savings" },
  { name: "checking" },
];
export default accountTypes;
